import { render, staticRenderFns } from "./CanceledPhds.vue?vue&type=template&id=547fe3e0&scoped=true&"
import script from "./CanceledPhds.vue?vue&type=script&lang=js&"
export * from "./CanceledPhds.vue?vue&type=script&lang=js&"
import style0 from "./CanceledPhds.vue?vue&type=style&index=0&id=547fe3e0&prod&lang=css&"
import style1 from "./CanceledPhds.vue?vue&type=style&index=1&id=547fe3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fe3e0",
  null
  
)

export default component.exports